<template>
  <div class="loader-container" :style="{'min-height':minHeight+'px', 'min-width':minWidth+'px'}">
    <template v-if="loading">
      <div class="loader-container__hover" :style="{'opacity': opacity}"></div>
      <div class="loader-container__message">
        <v-progress-circular indeterminate class="loader-container__loader" color="#ff721c"></v-progress-circular>
        <span >{{$t('please')}}<br/>{{$t('downloadData')}}</span>
      </div>
     </template>
    <template v-else-if="!loading && showNoDataText">
      <div class="loader-container__hover" :style="{'opacity': 1}"></div>
      <div class="loader-container__message">
        <span>{{$t('dataMissing')}}</span>
      </div>
    </template>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "LoaderWrapper",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    opacity: {
      type: [Number],
      default: 1
    },
    minWidth: {
      type: [Number],
      default: 0
    },
    minHeight: {
      type: [Number],
      default: 0
    },
    showNoDataText: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.loader-container {
  position: relative;
  background-color: white;

  .loader-container__hover {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: white;
    z-index: 4;
  }
  .loader-container__message {
    position: absolute;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    z-index: 5;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .loader-container__loader {
    z-index: 5;
  }
}
</style>
